import Navbar from "@/components/Navbar";
import CinematicHero from "@/components/landing/CinematicHero";
import SaCagnotte from "@/components/landing/SaCagnotte";
import NewHowItWorksSection from "@/components/landing/NewHowItWorksSection";
import InteractiveTimeline from "@/components/landing/InteractiveTimeline";
import TrustSection from "@/components/landing/TrustSection";
import BirthDateCalculator from "@/components/BirthDateCalculator";
import EmotionalFooter from "@/components/landing/EmotionalFooter";

const New4Landing = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="home" />
      <CinematicHero />
      <SaCagnotte />
      <NewHowItWorksSection />
      <BirthDateCalculator />
      <InteractiveTimeline />
      <TrustSection />
      <EmotionalFooter />
    </div>
  );
};

export default New4Landing;
